import axios from 'axios';
import config from '../config/config';
import {OVERVIEW_PROJECT_OVERVIEW_REQUEST, OVERVIEW_PROJECT_OVERVIEW_RECEIVE, OVERVIEW_CAMPING_STATS_REQUEST, OVERVIEW_CAMPING_STATS_RECEIVE} from "../config/actions";

export function getProjectOverview() {
    return dispatch => {
        dispatch({
            type: OVERVIEW_PROJECT_OVERVIEW_REQUEST
        });
        axios(config.server.endpoint + 'backend/project/overview/', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                if(response.data.success) {
                    dispatch({
                        type: OVERVIEW_PROJECT_OVERVIEW_RECEIVE,
                        data: response.data.project
                    });
                }
            }
        })
    }
}

export function getCampingStats() {
    return dispatch => {
        dispatch({ type: OVERVIEW_CAMPING_STATS_REQUEST });
        axios(config.server.endpoint + 'backend/campingStats/', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200 && response.data.success) {
                dispatch({
                    type: OVERVIEW_CAMPING_STATS_RECEIVE,
                    data: response.data.data
                });
            }
        });
    }
}